<template>
    <Head title="Lounge Finder" />
    <div class="px-4 md:px-8">
        <Lounges />
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import Lounges from '@/components/tools/lounges/lounges.vue';
</script>
